import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectOldMailTasksTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectOldMailTasksTab/components/ProspectOldMailTasksTabListing/ProspectOldMailTasksTabListing";
import BaseTaskTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseTaskTab/BaseTaskTab";

export default function ProspectOldMailTasksTab() {
    const {currentRoute} = useNavigation();
    const {prospect} = currentRoute.params;

    return (
        <BaseTaskTab
            listingComponent={<ProspectOldMailTasksTabListing prospectId={prospect}/>}
        />
    )
}
